import React, { useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { TextareaAutosize, TextField } from "@mui/material";
import { css, keyframes } from "@emotion/react";
import { useTheme } from "@mui/material/styles";
import { API } from "../../backend";
import { getAllCategoriesUnderParent } from "../../helper/categoryApiCalls/category";

const useStyles = makeStyles({
  input: {
    width: "100%",
    margin: "10px 0",
    outline: "none",
  },
  text: {
    fontSize: "14px",
    margin: 2,
  },
  textarea: {
    width: "100%",
    margin: "10px 0",
    resize: "none",
    height: "150px",
    overflowY: "scroll",
    outline: "none",
    "&:focus": {
      outline: "1px solid #139ded",
      borderRadius: "5px",
    },
    padding: "10px",
    border: "none",
    boxShadow: "1px 1px 1px 1px white",
    fontSize: "14px",
    lineHeight: "1.5",
  },
  button: {
    margin: "10px 0",
    width: "100%",
    borderRadius: "5px",
    padding: "20px",
    background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
    color: "white",
    cursor: "pointer",
    fontSize: "16px",
    border: "none",
    marginBottom: "10px",
  },
  modal: {
    "&::-webkit-scrollbar": {
      width: "0.5em",
    },
  },
  error: {
    color: "red",
    fontSize: "13px",
    marginTop: "10px",
    fontWeight: "600",
  },
});

const popup = keyframes`
50% {
  transform: scale(1.25);
}`;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "fit-content",
  overflowY: "scroll",
  bgcolor: "background.paper",
  border: "2px solid #4a1d85",
  boxShadow: 24,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: "fit-content",
  overflowY: "scroll",
  bgcolor: "background.paper",
  border: "2px solid #4a1d85",
  boxShadow: 24,
  p: 4,
};

function EditModal({
  open,
  setOpen,
  playlist,
  intialBranchCategory,
  initialBranchArray,
}) {
  const handleClose = () => setOpen(false);
  const [categories, setCategories] = React.useState([]);
  const [subcategories, setSubcategories] = React.useState([]);
  const [category, setCategory] = React.useState(null);
  const [subCategory, setSubCategory] = React.useState(null);
  const [desc, setDesc] = React.useState({
    name: playlist.name,

    description: playlist.description,
  });

  const [error, setError] = React.useState(false);
  console.log(intialBranchCategory, "branchCategory use", initialBranchArray);

  const [branchCategory, setBranchCategory] =
    React.useState(intialBranchCategory);
  console.log(branchCategory.length, "branchCategory");
  const [selectedBrach, setSelectedBranch] = React.useState(initialBranchArray);

  // pop up animation
  const theme = useTheme();
  const animatedItem = css`
    animation: ${popup} 0.4s ${theme.transitions.easing.easeInOut};
    animation-delay: 1s;
  `;

  const handleDesc = (e) => {
    setDesc({ ...desc, [e.target.name]: e.target.value });
  };
  async function handleCategory(event) {
    if (event.target.value) {
      const response = await getAllCategoriesUnderParent(event.target.value);
      if (response) {
        let newArr = [...branchCategory];
        let object = {
          index: 0,
          subCategories: response.data,
        };

        if (newArr.length === 0) {
          await newArr.push(object);
        } else {
          newArr = [];
          newArr.push(object);
        }

        setBranchCategory(newArr);
        setSelectedBranch([event.target.value]);
      }
    }
  }

  async function handleSubCat(e, index) {
    if (e.target.value) {
      const response = await getAllCategoriesUnderParent(e.target.value);

      if (response && response.data.length > 0) {
        let newArr = await branchCategory;

        let object = {
          index: index + 1,
          subCategories: response.data,
        };

        await newArr.push(object);

        await setBranchCategory(newArr);
      }
      if (selectedBrach.length > 0 && !selectedBrach[index + 1]) {
        setSelectedBranch((selectedBrach) => [
          ...selectedBrach,
          e.target.value,
        ]);
      } else {
        let otherBranch = [...selectedBrach];
        await otherBranch.splice(index + 1, otherBranch.length - (index + 1));

        let newOtherBranch = [...otherBranch];
        await newOtherBranch.push(e.target.value);
        await setSelectedBranch(newOtherBranch);

        if ([...branchCategory].length >= newOtherBranch.length) {
          let newupdatedBranchCat = await [...branchCategory].splice(
            index + 1,
            [...branchCategory].length - (index + 1)
          );

          let newupdatedArray = await [...branchCategory].filter(
            (n) => !newupdatedBranchCat.includes(n)
          );

          if (response && response.data.length > 0) {
            let object = {
              index: index + 1,
              subCategories: response.data,
            };
            await newupdatedArray.push(object);
            await setBranchCategory(newupdatedArray);
          } else {
            await setBranchCategory(newupdatedArray);
          }
        }
      }
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    var config = {
      method: "get",
      url: `${API}/category/getAll`,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("_access_token")
        )}`,
      },
    };

    const data = await axios(config);

    setCategories(data.data.data);
  }, []);

  console.log(desc);

  const editList = async () => {
    if (selectedBrach.length < 1) {
      setError(true);
      return;
    }

    var data = JSON.stringify({
      name: desc.name,
      description: desc.description,
      category: selectedBrach,
    });

    var config = {
      method: "put",
      url: `${API}/playlist/update/${playlist._id}`,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("_access_token")
        )}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const width = window.innerWidth;

  const classes = useStyles();

  return (
    <div className={classes.modal}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={width > 768 ? style : style2} className={classes.iframe}>
            <Typography variant="h6" id="transition-modal-title">
              Edit Playlist
            </Typography>
            <TextField
              id="outlined-basic"
              label="Topic"
              name="name"
              value={desc.name}
              className={classes.input}
              autoComplete="off"
              sx={{ my: 2 }}
              onChange={(e) => handleDesc(e)}
            />
            <Typography variant="h6" id="transition-modal-title">
              Description
            </Typography>
            <TextareaAutosize
              aria-label="maximum height"
              name="description"
              value={desc.description}
              className={classes.textarea}
              onChange={(e) => handleDesc(e)}
            />
            {error && (
              <span className={classes.error} css={animatedItem}>
                *Please select Category and Subcategory
              </span>
            )}
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel id="demo-simple-select-label">Category</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedBrach[0]}
                placeholder="Select Category"
                label="Category"
                onChange={handleCategory}
              >
                {categories.map((cat) => (
                  <MenuItem className={classes.menu} value={cat?._id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {branchCategory &&
              branchCategory.length > 0 &&
              branchCategory.map((bra, index) => {
                return (
                  <FormControl fullWidth sx={{ my: 2 }}>
                    <InputLabel id="demo-simple-select-label">
                      Sub-Category {index + 1}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedBrach[index + 1]}
                      label="Sub-Category"
                      placeholder="Sub-Category"
                      onChange={(e) => handleSubCat(e, index, bra.index)}
                    >
                      {bra?.subCategories?.length > 0 &&
                        bra?.subCategories?.map((cat) => {
                          return (
                            <MenuItem className={classes.menu} value={cat._id}>
                              {cat.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                );
              })}
            <button className={classes.button} onClick={editList}>
              Edit
            </button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default EditModal;
